import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter } from 'react-router-dom';

import { useGetRecord } from 'root/admin/components/hooks';
import { Title, Thumbnail, Images } from 'root/admin/components';
import ImagesNew from '../../components/images';

import store from 'root/admin/store';
import { Form, Field, Loader, Row, ManyToManySelect, DatePicker } from '@smartplatform/ui';
import { Editor } from '../../components';

const GalleryEdit = ({ match, rootPath, tabName }) => {
	const { id } = match.params;
	const options = { include: ['images'] };
	const record = useGetRecord({ model: 'Gallery', id, options, tabName });

	if (!record) {
		return <Loader />;
	}

	if (record && !record.id) {
		record.publishAt = new Date();
	}

	const onSave = () => {
		if (isNaN(id)) {
			store.history.push(`${rootPath}/galleries/${record.id}`);
			store.ui.setNotification({ message: 'Запись создана' });
		} else {
			store.history.push(`${rootPath}/galleries`);
			store.ui.setNotification({ message: 'Запись сохранена' });
		}
	};

	const onDelete = async () => {
		store.history.push(`${rootPath}/galleries`);
	};

	console.log(record);

	return (
		<div>
			<Title record={record} name="Галерея" />
			<Form record={record} rootPath={rootPath} onSave={onSave} onDelete={onDelete} stay>
				<Field property="name" label="Название" />
				<Field property="description" label="Краткое описание">
					<Editor />
				</Field>
				<Row>
					<Field property="publishAt" label="Дата и время публикации">
						<DatePicker showTimeSelect timeIntervals={15} />
					</Field>
					<Field property="removeAt" label="Дата и время снятия с публикации">
						<DatePicker showTimeSelect timeIntervals={15} />
					</Field>
				</Row>
				<Row>
					<Field property="publish" label="Опубликовать" />
				</Row>
				<Field label="Метки">
					<ManyToManySelect
						relation="tags"
						computed={type => <span title={type.id}>{type.name}</span>}
						itemTag={type => <span title={type.id}>{type.name}</span>}
						searchFields={['name']}
						filter={{ where: { type: { inq: ['gallery', 'all'] } } }}
					/>
				</Field>

				{record.imported ? (
					<img src={'/api/containers/attachments/download/' + record.thumbnailImported} alt={'Обложка'} width="50%" />
				) : (
					<Thumbnail record={record} label="Обложка альбома" />
				)}

				{record.id && (
					<ImagesNew
						record={record}
						relation="images"
						model={store.model.Attachment}
						property="filename"
						textProperty="name"
						getUrl={image =>
							record.imported ? '/api/containers/attachments/download/' + image.filename : image.downloadFile('filename')
						}
					/>
				)}
			</Form>
		</div>
	);
};

export default withRouter(GalleryEdit);
